import { Injectable } from '@angular/core';
import { ApiService, PagedResultGeneric } from 'src/app/shared';
import { CommitteeMeetingDto } from './dto/committee-meeting.dto';
import { CommitteeMeetingSearchDto } from './dto/committee-meeting-search.dto';
import { CommitteeMeetingMemberAttendanceSearchDto } from './dto/committee-meeting-member-attendance-search.dto';
import { CommitteeMeetingMemberAttendanceDto } from './dto/committee-meeting-member-attendance.dto';
import { FileService } from 'src/app/shared/file/file.service';
import { CommitteeMeetingFileTypeEnum } from './enum/committee-meeting-file-type.enum';

@Injectable({
  providedIn: 'root',
})
export class CommitteeMeetingService {
  constructor(private _apiService: ApiService, private _fileService: FileService) {}

  search(dto: CommitteeMeetingSearchDto): Promise<PagedResultGeneric<CommitteeMeetingDto>> {
    return this._apiService.post('CommitteeMeetings/Search', dto);
  }

  searchMeetingAttendance(
    dto: CommitteeMeetingMemberAttendanceSearchDto
  ): Promise<PagedResultGeneric<CommitteeMeetingMemberAttendanceDto>> {
    return this._apiService.post('CommitteeMeetings/SearchAttendance', dto);
  }

  get(id: number): Promise<CommitteeMeetingDto> {
    return this._apiService.get(`CommitteeMeeting/${id}`);
  }

  create(dto: CommitteeMeetingDto): Promise<number> {
    return this._apiService.post('CommitteeMeetings', dto);
  }

  update(dto: CommitteeMeetingDto): Promise<void> {
    return this._apiService.put(`CommitteeMeeting/${dto.MeetingID}`, dto);
  }

  delete(id: number) {
    return this._apiService.delete(`CommitteeMeeting/${id}`);
  }

  uploadFile(id: number, file: File, type: CommitteeMeetingFileTypeEnum): Promise<string> {
    const data = new FormData();
    data.append('file', file, file.name);
    return this._apiService.postRaw(`CommitteeMeeting/${id}/${type}`, data);
  }

  deleteFile(id: number, type: CommitteeMeetingFileTypeEnum): Promise<void> {
    return this._apiService.delete(`CommitteeMeeting/${id}/${type}`);
  }
}
